import { render, staticRenderFns } from "./dueForNosePunching.vue?vue&type=template&id=9d5a5a54&scoped=true&"
import script from "./dueForNosePunching.vue?vue&type=script&lang=js&"
export * from "./dueForNosePunching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d5a5a54",
  null
  
)

export default component.exports